module.exports = __webpack_public_path__ + "static/12-1dd26a84dc514c098ef47c6a3849e597.gif";